module.exports = __webpack_public_path__ + "static/media/logo-lg.1798862a.png";